import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

import { CityDTO } from "../../shared/models/city-dto";
import { CityAutoCompleteFiltersDTO } from "src/app/shared/models/city-auto-complete-filters-dto";

@Injectable({
  providedIn: "root"
})
export class CityService {
  private cityUrl = "cities/";

  constructor(private http: HttpClient) {}

  listAll(): Observable<CityDTO[]> {
    return this.http.get<CityDTO[]>(environment.apiUrl + this.cityUrl);
  }

  findById(id: number): Observable<CityDTO> {
    return this.http.get<CityDTO>(environment.apiUrl + `${this.cityUrl}${id}`);
  }

  findByStateId(stateId: number): Observable<CityDTO[]> {
    return this.http.get<CityDTO[]>(
      environment.apiUrl + `${this.cityUrl}filters?stateId=${stateId}`
    );
  }

  findByFilters(filters: CityAutoCompleteFiltersDTO): Observable<CityDTO[]> {
    let query = "?";

    if (filters.name) {
      query += `&name=${filters.name}`;
    }
    if (filters.stateId) {
      query += `&stateId=${filters.stateId}`;
    }

    return this.http.get<CityDTO[]>(
      environment.apiUrl + `${this.cityUrl}filters${query}`
    );
  }
}
